import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'isonApostrofos';
const args = {};

export class IsonApostrofos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
